module.exports = __webpack_public_path__ + "static/img/img-bg-2.37e36a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-bg-2.png
// module id = 9C2k
// module chunks = 0